import React from 'react';
import { withPrefix } from 'gatsby';
import classNames from 'classnames';
import { Header } from '../../Text/Header';
import { SponsorBar } from '../../SponsorBar';
import styles from './SmallArticleCard.styles';

const SmallArticleCard = ({ image, mobileImage, header, backgroundColor, logo, sponsorBar, className }) => (
  <div css={styles(backgroundColor)}>
    {sponsorBar && <SponsorBar />}
    <div className="small-card">
      <div className="small-card__image-container">
        {mobileImage ? (
          <img
            src={withPrefix(mobileImage)}
            alt="smallPostIllustration"
            className="small-card__image small-card__image--mobile"
          />
        ) : (
          <div className="plug-container-mobile" />
        )}
        {image ? (
          <img src={withPrefix(image)} alt="smallPostIllustration" className="small-card__image" />
        ) : (
          <div className="plug-container" />
        )}
      </div>
      <div className={classNames(sponsorBar && 'small-card__description-sponsor', 'small-card__description')}>
        {logo && (
          <img
            className={classNames('small-card__description-logo', className)}
            src={withPrefix(logo)}
            alt="logoImpact"
          />
        )}
        <Header text={header} fontSize={24} lineHeight={28} fontWeight="normal" letterSpacing={-1.2} />
      </div>
    </div>
  </div>
);

export default SmallArticleCard;
